export default {
  "&": {
    "#li-antibot-content": {
      boxShadow: "none !important",
      m: "0 !important",
      p: "0 !important",
    },

    "#li-antibot-text-purpose": {
      display: "none !important",
    },

    "#li-antibot-text": {
      fontFamily: "Marianne, arial, sans-serif !important",
      fontWeight: "400 !important",
      fontSize: "16px !important",
      lineHeight: "24px !important",
      mb: "16px",
    },
    "#li-antibot-sub-switcher": {
      fontFamily: "Marianne, arial, sans-serif !important",
      color: "#000091 !important",
    },

    "#li-antibot-refresh": {
      fontFamily: "Marianne, arial, sans-serif !important",
      color: "#000091 !important",
    },
    "#li-antibot-refresh:before": {
      width: "16px",
      height: "16px",
      content: "''",
      mask: "url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PHBhdGggZD0iTTUuNDYgNC40M2ExMCAxMCAwIDAgMSAxNC43MyAxMy4zTDE3IDEyLjAxaDNBOCA4IDAgMCAwIDYuNDYgNi4yM2wtMS0xLjh6bTEzLjA4IDE1LjE0QTEwIDEwIDAgMCAxIDMuOCA2LjI3TDcgMTEuOTlINGE4IDggMCAwIDAgMTMuNTQgNS43N2wxIDEuOHoiLz48L3N2Zz4=)",
      maskSize: "cover",
      bgcolor: "#000091",
      display: "inline-block",
      verticalAlign: "middle",
      mr: "8px",
      mb: "2px",
    },
    "#li-antibot-sub-switcher[aria-label='Répondre à une question']:before, #li-antibot-sub-switcher[aria-label='Answer a question']:before":
      {
        maskImage:
          "url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PHBhdGggZD0ibTkgNCA2LjQgMTZoLTIuMTU0bC0yLTVINC43NTRsLTIgNUguNkw3IDRoMlptMTQgOHY4aC0ydi0uNTM1YTQgNCAwIDEgMSAwLTYuOTNWMTJoMlptLTQgMmEyIDIgMCAxIDAgMCA0IDIgMiAwIDAgMCAwLTRaTTggNi44ODUgNS41NTQgMTNoNC44OTJMOCA2Ljg4NVoiLz48L3N2Zz4=)",

        width: "16px",
        height: "16px",
        content: "''",
        maskSize: "cover",
        bgcolor: "#000091",
        display: "inline-block",
        verticalAlign: "middle",
        mr: "8px",
      },
    "#li-antibot-sub-switcher[aria-label='Écouter un audio']:before, #li-antibot-sub-switcher[aria-label='Hear an audio']:before":
      {
        maskImage:
          "url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PHBhdGggZD0iTTYuOTA3IDE1LjMzM2gtMy4yNGEuODMzLjgzMyAwIDAgMS0uODM0LS44MzN2LTVjMC0uNDYuMzczLS44MzMuODM0LS44MzNoMy4yNGw0LjQxMi0zLjYxYS40MTcuNDE3IDAgMCAxIC42ODEuMzIydjEzLjI0MmEuNDE3LjQxNyAwIDAgMS0uNjguMzIybC00LjQxMi0zLjYxWk0xNy45MyA1LjAxQTkuMTQ3IDkuMTQ3IDAgMCAxIDIxLjE2NyAxMmE5LjE0NCA5LjE0NCAwIDAgMS0yLjk5NSA2Ljc3OGwtMS4xOC0xLjE4QTcuNDgyIDcuNDgyIDAgMCAwIDE5LjUgMTJhNy40ODUgNy40ODUgMCAwIDAtMi43NTMtNS44MDdMMTcuOTMgNS4wMVptLTIuOTY0IDIuOTY0QTQuOTkzIDQuOTkzIDAgMCAxIDE3IDEyYTQuOTkgNC45OSAwIDAgMS0xLjc4IDMuODI2bC0xLjE4Ni0xLjE4NWMuODItLjYzIDEuMy0xLjYwNyAxLjMtMi42NDFhMy4zMjkgMy4zMjkgMCAwIDAtMS41NjctMi44MjdsMS4xOTktMS4xOTlaIi8+PC9zdmc+)",

        width: "16px",
        height: "16px",
        content: "''",
        maskSize: "cover",
        bgcolor: "#000091",
        display: "inline-block",
        verticalAlign: "middle",
        mr: "8px",
      },

    "#li-antibot-answer": {
      "-webkit-font-smoothing": "antialiased",
      "-moz-osx-font-smoothing": "grayscale",
      "-webkit-text-size-adjust": "100%",
      border: 0,
      fontFamily: "Marianne, arial, sans-serif",
      textRendering: "optimizeLegibility",

      "--idle": "transparent",
      bgcolor: "#eee",
      borderRadius: ".25rem .25rem 0 0 !important",
      boxShadow: "inset 0 -2px 0 0 #3a3a3a",
      color: "#3a3a3a",
      display: "block",
      fontSize: "1rem",
      lineHeight: "1.5rem",
      padding: ".5rem 1rem !important",
    },
    "#li-antibot-validate": {
      mt: "1rem",
      boxShadow: "inset 0 0 0 1px #000091 !important",
      border: "none",
      borderRadius: "0 !important",

      "-webkit-appearance": "none",
      appearance: "none",
      cursor: "pointer",
      alignItems: "center",
      bgcolor: "transparent !important",
      color: "#000091 !important",
      display: "inline-flex",
      flexDirection: "row",
      fontSize: "1rem !important",
      fontWeight: "500 !important",
      lineHeight: "1.5rem !important",
      height: "40px !important",
      padding: ".5rem 1rem",
      width: "fit-content !important",

      fontFamily: "Marianne, arial, sans-serif !important",
    },
    "#li-antibot-validate:hover": {
      bgcolor: "#f6f6f6 !important",
    },
    "#li-antibot-validate:active": {
      bgcolor: "#ededed !important",
    },
    "#li-antibot-answer-container": {
      mt: "26px !important",
    },
    "#li-antibot-answer-instruction": {
      fontFamily: "Marianne, arial, sans-serif !important",
      fontWeight: "400 !important",
      display: "block !important",
      lineHeight: "1.25rem !important",
    },
  },
};
